import PropTypes from 'prop-types';
import { pageTypeIsRoot } from './pagetype';

const { shape, string, bool, number, arrayOf } = PropTypes;

// Represents the placement data we fetch from API
export const PlacementType = shape({
  platform: string.isRequired,
  categoryId: string.isRequired,
  countryCode: string.isRequired,
  isVirtual: bool.isRequired,
  containerId: string.isRequired,
  containerName: string.isRequired,
  placementCode: string.isRequired,
  sizes: arrayOf(arrayOf(number.isRequired)).isRequired,
});

export const findPlacement = (
  placementsMap,
  placementName,
  pathChain,
  pageType,
  siteMode
) => {
  const pathArray = Array.isArray(pathChain) ? pathChain.slice().reverse() : [];
  if (pageTypeIsRoot(pageType)) {
    pathArray.push('root');
  }
  pathArray.push('fallback');
  for (let i = 0; i < pathArray.length; i += 1) {
    const key = `${siteMode}:${placementName}:${pathArray[i]}`;
    if (placementsMap[key]) {
      return key;
    }
  }
  return null;
};

export default {
  PlacementType,
  findPlacement,
};
